module.exports = __webpack_public_path__ + "img/software.16547c91.png";